import { render, staticRenderFns } from "./roomTree.vue?vue&type=template&id=10f3826b&scoped=true"
import script from "./roomTree.vue?vue&type=script&lang=js"
export * from "./roomTree.vue?vue&type=script&lang=js"
import style0 from "./roomTree.vue?vue&type=style&index=0&id=10f3826b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f3826b",
  null
  
)

export default component.exports